// constants.js

import {
    Type,
    Image as ImageIcon,
    Code,
    Palette,
    Share2,
    Box,
    CaseSensitive,
    FileText,
    Binary,
    Maximize,
    Scan,
    Layout,
    Terminal,
    Cpu,
    Hash,
    Fingerprint,
    Mail,
    Zap,
    Sparkles,
    Search,
    Globe,
    Loader2,
    CheckSquare,
    ToggleLeft,
    Scissors,
    Layers,
    Activity,
    BoxSelect,
    Triangle,
    CornerUpRight,
    File,
    Clock,
    KeyboardIcon,
    Calculator,
    Repeat,
    Plus,
    TrendingUp,
    ActivityIcon,
    Trash2,
    MouseIcon,
    ArrowLeftCircle,
    MicIcon,
    Bandage,
    KeyboardMusic,
    FileType,
    ChartNoAxesGantt,
    Kanban,
    CopyCheck,
    Replace,
    Undo2,
    Diff,
    Tally5,
    BookType,
    FileBraces,
    Eclipse,
    Link2,
    ShieldBan,
    Lock,
    Bug,
    TestTube,
    FileScan,
    Timer,
    TimerReset,
    Calendar1,
    CalendarDays,
    Scale,
    SquareRadical,
    SunSnow,
    CircuitBoard,
    Percent,
    CircleDollarSign,
    Banknote,
    RefreshCcw,
    Ruler,
    Tag,
    GraduationCap,
    Wallet,
    Home,
    Fuel,
    Apple,
    ShoppingCart,
    ImageUp,
    Move,
    Droplet,
    Music,
    Eye,
    Image,
    Video,
    Thermometer,
    Gauge,
    HardDrive,
    FileSpreadsheet,
    FileImage,
    Key,
    QrCode,
    Barcode,
    Shuffle,
    UserPlus,
    Database,
    Receipt,
    Award,
    PenTool,
    Columns,
    Dices,
    Users,
    RotateCw,
    StickyNote,
    Pencil,
    LucideScanFace
} from 'lucide-react';

// Define categories as simple strings (no enum needed in JS)
export const ToolCategory = {
    TYPING: 'Typing & Keyboard Tools',
    TEXT: 'Text & Writing Tools',
    IMAGE: 'Image Tools',
    CODING: 'Coding Tools',
    COLOR: 'Color Tools',
    SOCIAL: 'Social Media Tools',
    MISC: 'Miscellaneous Tools',
    TIME: 'Time & Date Tools',
    CALCULATORS: 'Calculators',
    CONVERTERS: 'Converters',
    GENERATORS: 'Generators',
    PRODUCTIVITY: 'Productivity Tools',
    ENTERTAINMENT: 'Fun & Entertainment Tools',
};

export const TOOLS = [
    // CSS Tools (using IMAGE category for visual/CSS generators)
    // Coding Tools


    {
        id: 'json-formatter',
        name: 'JSON Formatter',
        description: 'Format JSON data for better readability.',
        icon: 'FileBraces',
        category: ToolCategory.CODING
    },

    {
        id: 'css-minifier',
        name: "CSS Minifier",
        description: "Minify CSS code and remove unnecessary characters.",
        icon: "Eclipse",
        category: ToolCategory.CODING


    },
    {
        id: 'javascript-minifier',
        name: "JavaScript Minifier",
        description: "Minify JavaScript code and remove unnecessary characters.",
        icon: "Eclipse",
        category: ToolCategory.CODING


    },
    {
        id: 'html-formatter',
        name: "HTML Formatter",
        description: "Format HTML code for better readability.",
        icon: "Eclipse",
        category: ToolCategory.CODING


    },
    {
        id: 'code-beautifier',
        name: "Code Beautifier",
        description: "Beautify and format source code for improved readability.",
        icon: "Code",
        category: ToolCategory.CODING
    },

    {
        id: 'regex-tester',
        name: "Regex Tester",
        description: "Test and debug regular expressions in real time.",
        icon: "Search",
        category: ToolCategory.CODING
    },

    {
        id: 'base64-encoder-decoder',
        name: "Base64 Encoder/Decoder",
        description: "Encode or decode Base64 strings instantly.",
        icon: "Repeat",
        category: ToolCategory.CODING
    },

    {
        id: 'url-encoder-decoder',
        name: "URL Encoder/Decoder",
        description: "Encode or decode URLs to make them web-safe.",
        icon: "Link2",
        category: ToolCategory.CODING
    },

    {
        id: 'md5-hash-generator',
        name: "MD5 Hash Generator",
        description: "Create an MD5 hash (checksum) from text.",
        icon: "Lock",
        category: ToolCategory.CODING
    },

    {
        id: 'sha1-hash-generator',
        name: "SHA-1 Hash Generator",
        description: "Generate SHA-1 hashes for data integrity checks.",
        icon: "ShieldBan",
        category: ToolCategory.CODING
    },

    {
        id: 'sha224-hash-generator',
        name: "SHA-224 Hash Generator",
        description: "Generate SHA-224 hashes for checksum workflows.",
        icon: "ShieldBan",
        category: ToolCategory.CODING
    },

    {
        id: 'sha256-hash-generator',
        name: "SHA-256 Hash Generator",
        description: "Create SHA-256 hashes for verification and checksums.",
        icon: "ShieldBan",
        category: ToolCategory.CODING
    },

    {
        id: 'sha384-hash-generator',
        name: "SHA-384 Hash Generator",
        description: "Generate SHA-384 hashes for integrity verification.",
        icon: "ShieldBan",
        category: ToolCategory.CODING
    },

    {
        id: 'sha512-hash-generator',
        name: "SHA-512 Hash Generator",
        description: "Create SHA-512 hashes for checksum and integrity use.",
        icon: "ShieldBan",
        category: ToolCategory.CODING
    },

    {
        id: 'jwt-debugger',
        name: "JWT Debugger",
        description: "Decode, verify, and debug JSON Web Tokens.",
        icon: "Bug",
        category: ToolCategory.CODING
    },

    {
        id: 'api-tester',
        name: "API Tester",
        description: "Test REST APIs with custom headers, params, and payloads.",
        icon: "TestTube",
        category: ToolCategory.CODING
    },

    {
        id: 'markdown-preview',
        name: "Markdown Preview",
        description: "Preview Markdown content as formatted HTML.",
        icon: "FileText",
        category: ToolCategory.CODING
    },

    {
        id: 'json-difference-checker',
        name: "JSON Difference Checker",
        description: "Compare two JSON objects and highlight differences.",
        icon: "Diff",
        category: ToolCategory.CODING
    },

    {
        id: 'code-to-image-converter',
        name: "Code to Image Converter",
        description: "Convert code snippets into shareable images.",
        icon: "FileScan",
        category: ToolCategory.CODING
    },
    {
        id: 'moltbot-prompt-generator',
        name: "MoltBot Prompt Generator",
        description: "Generate MoltBot Prompt Using AI",
        icon: "LucideScanFace",
        category: ToolCategory.CODING
    },

    //Image Tools
    {
        id: 'image-compressor',
        name: "Image Compressor",
        description: "Compress images to reduce file size without losing quality.",
        icon: "ImageUp",
        category: ToolCategory.IMAGE
    },

    {
        id: 'image-resizer',
        name: "Image Resizer",
        description: "Resize images to custom dimensions easily.",
        icon: "Move",
        category: ToolCategory.IMAGE
    },

    // {
    //     id: 'background-remover',
    //     name: "Background Remover",
    //     description: "Remove image backgrounds automatically and accurately.",
    //     icon: "Scissors",
    //     category: ToolCategory.IMAGE
    // },

    {
        id: 'watermark-maker',
        name: "Watermark Maker",
        description: "Add custom text or image watermarks to protect images.",
        icon: "Droplet",
        category: ToolCategory.IMAGE
    },

    {
        id: 'audio-trimmer',
        name: "Audio Trimmer",
        description: "Trim and cut audio files to desired length.",
        icon: "Music",
        category: ToolCategory.IMAGE
    },

    {
        id: 'svg-viewer',
        name: "SVG Viewer",
        description: "View and inspect SVG files directly in the browser.",
        icon: "Eye",
        category: ToolCategory.IMAGE
    },

    // Text Tools

    {
        id: 'case-converter',
        name: 'Case Converter',
        description: 'Convert text to UPPERCASE, lowercase, CamelCase, etc.',
        icon: 'CaseSensitive',
        category: ToolCategory.TEXT
    },
    {
        id: 'character-counter',
        name: "Character Counter",
        description: "Count the number of characters in your text.",
        icon: "FileType",
        category: ToolCategory.TEXT
    },
    {
        id: 'remove-line-breaks',
        name: "Remove Line Breaks",
        description: "Remove line breaks from your text.",
        icon: "ChartNoAxesGantt",
        category: ToolCategory.TEXT
    },
    {
        id: 'lorem-ipsum-generator',
        name: "Lorem Ipsum Generator",
        description: "Generate Lorem Ipsum text.",
        icon: "Kanban",
        category: ToolCategory.TEXT

    },
    {
        id: 'duplicate-word-finder',
        name: "Duplicate Word Finder",
        description: "Find duplicate words in a text.",
        icon: "CopyCheck",
        category: ToolCategory.TEXT,


    },
    {
        id: 'find-and-replace',
        name: "Find and Replace",
        description: "Find and replace text in a document.",
        icon: "Replace",
        category: ToolCategory.TEXT,


    },
    {
        id: 'reverse-text',
        name: "Reverse Text",
        description: "Reverse the order of characters in a text.",
        icon: "Undo2",
        category: ToolCategory.TEXT,


    },
    {
        id: 'text-comparison',
        name: "Text Comparison",
        description: "Compare two texts and highlight the differences.",
        icon: "Diff",
        category: ToolCategory.TEXT,


    },
    {
        id: 'sentence-counter',
        name: "Sentence Counter",
        description: "Count the number of sentences in your text.",
        icon: "Tally5",
        category: ToolCategory.TEXT
    },
    {
        id: 'text-encryption-decryption',
        name: "Text Encryption & Decryption",
        description: "Encrypt and decrypt text.",
        icon: "BookType",
        category: ToolCategory.TEXT
    },
    // {
    //     id: 'text-to-handwriting',
    //     name: "Handwriting Style Renderer",
    //     description: "Render typed text in handwriting styles for design mockups.",
    //     icon: "Pencil",
    //     category: ToolCategory.TEXT
    // },



    // Time & Date Tools
    {
        id: 'countdown-timer',
        name: "Countdown Timer",
        description: "Set a countdown timer for events, tasks, or deadlines.",
        icon: "Timer",
        category: ToolCategory.TIME
    },

    {
        id: 'stopwatch-with-laps',
        name: "Stopwatch (with Laps)",
        description: "Measure elapsed time with lap tracking support.",
        icon: "TimerReset",
        category: ToolCategory.TIME
    },

    {
        id: 'age-calculator',
        name: "Age Calculator",
        description: "Calculate age accurately based on date of birth.",
        icon: "Calculator",
        category: ToolCategory.TIME
    },

    {
        id: 'days-between-dates-calculator',
        name: "Days Between Dates Calculator",
        description: "Find the number of days between two dates.",
        icon: "Calendar1",
        category: ToolCategory.TIME
    },

    {
        id: 'time-zone-converter',
        name: "Time Zone Converter",
        description: "Convert time between different time zones worldwide.",
        icon: "Globe",
        category: ToolCategory.TIME
    },

    {
        id: 'world-clock',
        name: "World Clock",
        description: "View current time across multiple countries and cities.",
        icon: "Clock",
        category: ToolCategory.TIME
    },

    {
        id: 'calendar-generator',
        name: "Calendar Generator",
        description: "Generate monthly or yearly calendars instantly.",
        icon: "CalendarDays",
        category: ToolCategory.TIME
    },

    {
        id: 'zodiac-sign-finder',
        name: "Zodiac Sign Finder",
        description: "Find your zodiac sign based on your birth date.",
        icon: "Scale",
        category: ToolCategory.TIME
    },

    {
        id: 'quarter-calculator',
        name: "Quarter Calculator",
        description: "Determine financial or calendar quarters for any date.",
        icon: "SquareRadical",
        category: ToolCategory.TIME
    },

    {
        id: 'iso-week-date-converter',
        name: "ISO Week Date Converter",
        description: "Convert dates to ISO week number format and vice versa.",
        icon: "Hash",
        category: ToolCategory.TIME
    },

    {
        id: 'season-finder',
        name: "Season Finder",
        description: "Identify the season based on a given date and location.",
        icon: "SunSnow",
        category: ToolCategory.TIME
    },

    // Typing & Keyboard Tools
    {
        id: 'spacebar-counter',
        name: 'Spacebar Counter',
        description: 'Count the number of times you press the spacebar.',
        icon: 'KeyboardIcon',
        category: ToolCategory.TYPING
    },
    {
        id: 'word-counter',
        name: 'Word Counter',
        description: 'Count the number of words in your text.',
        icon: 'FileText',
        category: ToolCategory.TYPING
    },
    {
        id: 'cps-click-tester',
        name: 'CPS Click Tester',
        description: 'Test your clicking speed and CPS (clicks per second) in real-time.',
        icon: 'ActivityIcon',
        category: ToolCategory.TYPING
    },
    {
        id: 'typing-speed-tester',
        name: 'Typing Speed Tester',
        description: 'Test you  typing speed and accuracy in real-time.',
        icon: 'Type',
        category: ToolCategory.TYPING
    },
    {
        id: 'double-space-remover',
        name: "Double Space Remover",
        description: "Remove double spaces, extra tabs, and multiple spaces in a single click.",
        icon: "Trash2",
        category: ToolCategory.TYPING

    },
    {
        id: 'keyboard-tester',
        name: "Keyboard Tester", description: "Test your typing speed and accuracy with our free online keyboard tester. Real-time tracking of keys pressed, accuracy percentage, and personal rank.",
        icon: "KeyboardIcon",
        category: ToolCategory.TYPING
    },
    {
        id: 'scroll-speed-tester',
        name: 'Scroll Speed Tester',
        description: 'Test your scrolling speed and accuracy with our free online scroll speed tester. Real-time tracking of scrolls, scroll distance, and scroll time.',
        icon: 'MouseIcon',
        category: ToolCategory.TYPING
    },
    {
        id: 'auto-keypress-counter',
        name: 'Auto Keypress Counter',
        description: 'Count the number of keypresses in a specified time period.',
        icon: 'ActivityIcon',
        category: ToolCategory.TYPING
    },
    {
        id: 'backspace-counter',
        name: "Backspace Counter",
        description: "Count the number of backspaces in a specified time period.",
        icon: "ArrowLeftCircle",
        category: ToolCategory.TYPING
    },
    {
        id: 'typing-accuracy-checker',
        name: "Typing Accuracy Checker",
        description: "Check your typing accuracy in real-time.",
        icon: "KeyboardMusic",
        category: ToolCategory.TYPING
    },
    {
        id: 'keyboard-heatmap-visulizer',
        name: "Keyboard Heatmap Visualizer",
        description: "Visualize your keyboard heatmap in real-time.",
        icon: "Bandage",
        category: ToolCategory.TYPING
    },
    {
        id: 'key-sound-customizer',
        name: "Keyboard Sound Customizer",
        description: "Customize the sound of your keyboard keys.",
        icon: "MicIcon",
        category: ToolCategory.TYPING
    },




    // Calculators
    {
        id: 'basic-calculator',
        name: "Basic Calculator",
        description: "Perform basic arithmetic operations quickly and easily.",
        icon: "Calculator",
        category: ToolCategory.CALCULATORS
    },
    {
        id: 'scientific-calculator',
        name: "Scientific Calculator",
        description: "Advanced calculator with scientific and trigonometric functions.",
        icon: "CircuitBoard",
        category: ToolCategory.CALCULATORS
    },
    {
        id: 'bmi-calculator',
        name: "BMI Calculator",
        description: "Calculate Body Mass Index using height and weight.",
        icon: "Activity",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'percentage-calculator',
        name: "Percentage Calculator",
        description: "Calculate percentages, increases, and decreases easily.",
        icon: "Percent",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'tip-calculator',
        name: "Tip Calculator",
        description: "Calculate tips and split bills among people.",
        icon: "CircleDollarSign",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'loan-emi-calculator',
        name: "Loan EMI Calculator",
        description: "Calculate monthly EMI for loans with interest rates.",
        icon: "Banknote",
        category: ToolCategory.CALCULATORS
    },

    // {
    //     id: 'currency-converter',
    //     name: "Currency Converter",
    //     description: "Convert between global currencies using live rates.",
    //     icon: "RefreshCcw",
    //     category: ToolCategory.CALCULATORS
    // },

    {
        id: 'unit-converter',
        name: "Unit Converter",
        description: "Convert units of length, weight, temperature, and more.",
        icon: "Ruler",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'discount-calculator',
        name: "Discount Calculator",
        description: "Calculate final prices after discounts and offers.",
        icon: "Tag",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'gpa-calculator',
        name: "GPA Calculator",
        description: "Calculate Grade Point Average for academic results.",
        icon: "GraduationCap",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'compound-interest-calculator',
        name: "Compound Interest Calculator",
        description: "Calculate compound interest and investment growth.",
        icon: "TrendingUp",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'salary-calculator',
        name: "Salary Calculator",
        description: "Estimate take-home salary after deductions and taxes.",
        icon: "Wallet",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'mortgage-calculator',
        name: "Mortgage Calculator",
        description: "Calculate mortgage payments and interest over time.",
        icon: "Home",
        category: ToolCategory.CALCULATORS
    },

    // {
    //     id: 'fuel-cost-calculator',
    //     name: "Fuel Cost Calculator",
    //     description: "Estimate fuel expenses for trips based on distance.",
    //     icon: "Fuel",
    //     category: ToolCategory.CALCULATORS
    // },

    {
        id: 'calorie-calculator',
        name: "Calorie Calculator",
        description: "Calculate daily calorie needs based on body metrics.",
        icon: "Apple",
        category: ToolCategory.CALCULATORS
    },

    {
        id: 'shopify-profit-calculator',
        name: "Shopify Profit Calculator",
        description: "Calculate profit margins for Shopify product sales.",
        icon: "ShoppingCart",
        category: ToolCategory.CALCULATORS
    },
    // Converters

    {
        id: 'image-to-pdf',
        name: 'Image to PDF Converter',
        description: 'Convert images to PDF with customizable page size, orientation, and margins.',
        icon: 'File',
        category: ToolCategory.CONVERTERS
    },
    {
        id: 'image-format-converter',
        name: "Image Format Converter",
        description: "Convert images between formats like JPG, PNG, and WEBP.",
        icon: "Image",
        category: ToolCategory.CONVERTERS
    },

    // {
    //     id: 'pdf-to-word-converter',
    //     name: "PDF to Word Converter",
    //     description: "Convert PDF documents into editable Word files.",
    //     icon: "FileText",
    //     category: ToolCategory.CONVERTERS
    // },

    // {
    //     id: 'video-format-converter',
    //     name: "Video Format Converter",
    //     description: "Convert videos between popular formats easily.",
    //     icon: "Video",
    //     category: ToolCategory.CONVERTERS
    // },

    // {
    //     id: 'audio-format-converter',
    //     name: "Audio Format Converter",
    //     description: "Convert audio files between MP3, WAV, and other formats.",
    //     icon: "Music",
    //     category: ToolCategory.CONVERTERS
    // },

    {
        id: 'temperature-converter',
        name: "Temperature Converter",
        description: "Convert temperature between Celsius, Fahrenheit, and Kelvin.",
        icon: "Thermometer",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'length-converter',
        name: "Length Converter",
        description: "Convert length units like meters, kilometers, and miles.",
        icon: "Ruler",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'weight-converter',
        name: "Weight Converter",
        description: "Convert weight units such as kg, grams, and pounds.",
        icon: "Scale",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'speed-converter',
        name: "Speed Converter",
        description: "Convert speed units like km/h, mph, and m/s.",
        icon: "Gauge",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'data-size-converter',
        name: "Data Size Converter",
        description: "Convert data sizes between KB, MB, GB, and TB.",
        icon: "HardDrive",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'number-base-converter',
        name: "Number Base Converter",
        description: "Convert numbers between binary, decimal, octal, and hex.",
        icon: "Binary",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'rgb-to-hex-converter',
        name: "RGB to HEX Converter",
        description: "Convert RGB color values into HEX format.",
        icon: "Palette",
        category: ToolCategory.CONVERTERS
    },

    {
        id: 'json-to-csv-converter',
        name: "JSON to CSV Converter",
        description: "Convert JSON data into CSV format for spreadsheets.",
        icon: "FileSpreadsheet",
        category: ToolCategory.CONVERTERS
    },



    // Generators
    {
        id: 'password-generator',
        name: "Password Generator",
        description: "Generate strong and secure passwords instantly.",
        icon: "Key",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'qr-code-generator',
        name: "QR Code Generator",
        description: "Create QR codes for URLs, text, and contact details.",
        icon: "QrCode",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'barcode-generator',
        name: "Barcode Generator",
        description: "Generate barcodes for products and inventory.",
        icon: "Barcode",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'random-number-generator',
        name: "Random Number Generator",
        description: "Generate random numbers within a custom range.",
        icon: "Shuffle",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'username-generator',
        name: "Username Generator",
        description: "Generate unique and creative usernames instantly.",
        icon: "UserPlus",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'color-palette-generator',
        name: "Color Palette Generator",
        description: "Generate beautiful color palettes for designs.",
        icon: "Palette",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'sample-data-generator',
        name: "Sample Data Generator",
        description: "Generate sample data for testing, demos, and development.",
        icon: "Database",
        category: ToolCategory.GENERATORS
    },

    {
        id: 'receipt-generator',
        name: "Purchase Record Builder",
        description: "Create purchase record templates for bookkeeping and expenses.",
        icon: "Receipt",
        category: ToolCategory.GENERATORS
    },

    // {
    //     id: 'invoice-generator',
    //     name: "Invoice Template Maker",
    //     description: "Build professional invoice templates for clients and accounting.",
    //     icon: "FileText",
    //     category: ToolCategory.GENERATORS
    // },

    // {
    //     id: 'certificate-generator',
    //     name: "Certificate Generator",
    //     description: "Create custom certificates for events and courses.",
    //     icon: "Award",
    //     category: ToolCategory.GENERATORS
    // },

    // {
    //     id: 'meme-generator',
    //     name: "Meme Generator",
    //     description: "Create and customize memes with images and text.",
    //     icon: "Smile",
    //     category: ToolCategory.GENERATORS
    // },

    {
        id: 'signature-generator',
        name: "Signature Style Creator",
        description: "Create stylized signature text for design and branding.",
        icon: "PenTool",
        category: ToolCategory.GENERATORS
    },

    // Productivity Tools
    // {
    //     id: 'to-do-list',
    //     name: "To-Do List",
    //     description: "Organize tasks and manage your daily to-do items.",
    //     icon: "CheckSquare",
    //     category: ToolCategory.PRODUCTIVITY
    // },

    // {
    //     id: 'notes-app',
    //     name: "Notes App",
    //     description: "Write, save, and organize notes effortlessly.",
    //     icon: "StickyNote",
    //     category: ToolCategory.PRODUCTIVITY
    // },

    // {
    //     id: 'habit-tracker',
    //     name: "Habit Tracker",
    //     description: "Track daily habits and build consistency over time.",
    //     icon: "Repeat",
    //     category: ToolCategory.PRODUCTIVITY
    // },

    {
        id: 'kanban-board',
        name: "Kanban Board",
        description: "Manage projects visually using kanban-style boards.",
        icon: "Columns",
        category: ToolCategory.PRODUCTIVITY
    },

    // Fun & Entertainment Tools
    // {
    //     id: 'dice-roller',
    //     name: "Dice Roller",
    //     description: "Roll virtual dice with customizable sides.",
    //     icon: "Dices",
    //     category: ToolCategory.ENTERTAINMENT
    // },

    // {
    //     id: 'coin-flipper',
    //     name: "Coin Flipper",
    //     description: "Flip a virtual coin for quick decisions.",
    //     icon: "CircleDollarSign",
    //     category: ToolCategory.ENTERTAINMENT
    // },

    {
        id: 'random-name-picker',
        name: "Random Name Picker",
        description: "Pick a random name from a custom list.",
        icon: "Users",
        category: ToolCategory.ENTERTAINMENT
    },

    // {
    //     id: 'spin-the-wheel',
    //     name: "Spin the Wheel",
    //     description: "Spin a wheel to randomly select an option.",
    //     icon: "RotateCw",
    //     category: ToolCategory.ENTERTAINMENT
    // },

];

export const CATEGORIES = [
    {
        id: ToolCategory.CODING,
        name: 'Coding Tools',
        icon: <Code className="w-4 h-4" />,
        color: 'emerald'
    },
    // {
    //     id: ToolCategory.COLOR,
    //     name: 'Color Tools',
    //     icon: <Zap className="w-4 h-4" />,
    //     color: 'pink'
    // },
    // {
    //     id: ToolCategory.SOCIAL,
    //     name: 'Social Media',
    //     icon: <Share2 className="w-4 h-4" />,
    //     color: 'indigo'
    // },
    // {
    //     id: ToolCategory.MISC,
    //     name: 'Miscellaneous',
    //     icon: <Box className="w-4 h-4" />,
    //     color: 'slate'
    // },
    // Optional: Add Text Tools category if you want it visible in header/marquee
    {
        id: ToolCategory.TEXT,
        name: 'Text Tools',
        icon: <Type className="w-4 h-4" />,
        color: 'purple'
    },
    {
        id: ToolCategory.TIME,
        name: 'Time & Date Tools',
        icon: <Clock className="w-4 h-4" />,
        color: 'orange'
    },
    {
        id: ToolCategory.TYPING,
        name: 'Typing & Keyboard Tools',
        icon: <KeyboardIcon className="w-4 h-4" />,
        color: 'purple'
    },
    {
        id: ToolCategory.CALCULATORS,
        name: 'Calculators',
        icon: <Calculator className="w-4 h-4" />,
        color: 'green'
    },
    {
        id: ToolCategory.IMAGE,
        name: 'Image & Media Tools',
        icon: <ImageIcon className="w-4 h-4" />,
        color: 'red'
    },
    {
        id: ToolCategory.CONVERTERS,
        name: 'Converters',
        icon: <Repeat className="w-4 h-4" />,
        color: 'yellow'
    },
    {
        id: ToolCategory.GENERATORS,
        name: 'Generators',
        icon: <Plus className="w-4 h-4" />,
        color: 'blue'
    },
    {
        id: ToolCategory.PRODUCTIVITY,
        name: 'Productivity Tools',
        icon: <TrendingUp className="w-4 h-4" />,
        color: 'green'
    },
    {
        id: ToolCategory.ENTERTAINMENT,
        name: 'Fun & Entertainment Tools',
        icon: <ActivityIcon className="w-4 h-4" />,
        color: 'red'
    },
];

export const ICON_MAP = {
    Type,
    ImageIcon,
    Code,
    Palette,
    Share2,
    Box,
    CaseSensitive,
    FileText,
    Binary,
    Maximize,
    Scan,
    Layout,
    Terminal,
    Cpu,
    Hash,
    Fingerprint,
    Mail,
    Zap,
    Sparkles,
    Search,
    Globe,
    Loader2,
    CheckSquare,
    ToggleLeft,
    Scissors,
    Layers,
    Activity,
    BoxSelect,
    Triangle,
    CornerUpRight,
    File,
    Clock,
    KeyboardIcon,
    Calculator,
    Repeat,
    Plus,
    TrendingUp,
    ActivityIcon,
    Trash2,
    MouseIcon,
    ArrowLeftCircle,
    MicIcon,
    Bandage,
    KeyboardMusic,
    FileType,
    ChartNoAxesGantt,
    Kanban,
    CopyCheck,
    Replace,
    Undo2,
    Diff,
    Tally5,
    BookType,
    FileBraces,
    Eclipse,
    Link2,
    ShieldBan,
    Lock,
    Bug,
    TestTube,
    FileScan,
    Timer,
    TimerReset,
    Calendar1,
    CalendarDays,
    Scale,
    SquareRadical,
    SunSnow,
    CircuitBoard,
    Percent,
    CircleDollarSign,
    Banknote,
    RefreshCcw,
    Ruler,
    Tag,
    GraduationCap,
    Wallet,
    Home,
    Fuel,
    Apple,
    ShoppingCart,
    ImageUp,
    Move,
    Droplet,
    Music,
    Eye,
    Image,
    Video,
    Thermometer,
    Gauge,
    HardDrive,
    FileSpreadsheet,
    FileImage,
    Key,
    QrCode,
    Barcode,
    Shuffle,
    UserPlus,
    Database,
    Receipt,
    Award,
    PenTool,
    Columns,
    Dices,
    Users,
    RotateCw,
    StickyNote,
    Pencil,
    LucideScanFace

};

export const TOOL_CONTENT = {
    "receipt-generator": {
        summary: "Create clean, printable purchase record templates for bookkeeping and expense tracking.",
        details: [
            "Use this tool to build standardized receipt layouts for internal records or training materials.",
            "It is intended for legitimate accounting, inventory, and expense documentation workflows."
        ],
        useCases: [
            "Create a consistent purchase record format for staff training.",
            "Prepare sample receipts for bookkeeping practice or QA.",
            "Draft a template to mirror your existing POS layout."
        ],
        noticeTitle: "Responsible Use",
        noticeBody: "Use this tool for legitimate record-keeping and training. Do not create documents intended to mislead or misrepresent real transactions."
    },
    "invoice-generator": {
        summary: "Build invoice templates with consistent fields for client billing and internal accounting.",
        details: [
            "Generate a clean invoice layout you can reuse across clients and projects.",
            "Designed for legitimate billing, bookkeeping, and finance workflows."
        ],
        useCases: [
            "Create a reusable invoice format for contractors or freelancers.",
            "Standardize invoice fields for accounting reviews.",
            "Draft invoice layouts for internal approvals."
        ],
        noticeTitle: "Responsible Use",
        noticeBody: "Use only for lawful billing and record-keeping. Do not create misleading or counterfeit financial documents."
    },
    "dummy-data-generator": {
        summary: "Generate sample datasets for testing, demos, and development environments.",
        details: [
            "Create realistic-looking data without exposing real user or customer records.",
            "Useful for UI demos, QA, and development seed data."
        ],
        useCases: [
            "Populate staging databases with non-sensitive sample records.",
            "Demo dashboards and analytics views safely.",
            "Test import/export flows without real customer data."
        ],
        noticeTitle: "Responsible Use",
        noticeBody: "Do not use generated data to impersonate real people or organizations."
    },
    "signature-generator": {
        summary: "Create stylized signature text for branding, mockups, and design assets.",
        details: [
            "Generate decorative signature styles for presentations, logos, or digital art.",
            "Not intended for legal signing or identity verification."
        ],
        useCases: [
            "Create a stylized signature for a portfolio or design mockup.",
            "Add a signature-style footer to a marketing asset.",
            "Explore typography styles for branding."
        ],
        noticeTitle: "Responsible Use",
        noticeBody: "Do not use for legal agreements, identity verification, or impersonation."
    },
    "text-to-handwriting": {
        summary: "Render typed text in handwriting styles for educational and design use.",
        details: [
            "Convert typed content into handwriting-like visual styles for mockups.",
            "Great for posters, study notes, and presentation visuals."
        ],
        useCases: [
            "Create handwriting-style headings for a presentation.",
            "Mock up handwritten notes for a design project.",
            "Generate styled text for educational visuals."
        ],
        noticeTitle: "Responsible Use",
        noticeBody: "Do not use to imitate real individuals or create misleading documents."
    }
};

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.example.com';
export const BLOG_API_URL = `${API_BASE_URL}/blogs`;
